import type { UseFormWatch } from 'react-hook-form';
import type { FormConfig, FormValues, PossibleValues } from './types.ts';

export const evaluateDependencies = (
  dependsOn: FormConfig[0]['dependsOn'],
  watch: UseFormWatch<FormValues>,
) => {
  if (!dependsOn) {
    return true;
  }

  const testFunction = dependsOn.logicalOperator === 'and' ? 'every' : 'some';

  return dependsOn.dependencies[testFunction]((dependency) => {
    const { id, value: dependencyValue } = dependency;
    const value = watch(id);
    return compareValues(value, dependencyValue);
  });
};

const compareValues = <T extends PossibleValues>(a: T, b: T): boolean => {
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) {
      return false;
    }
    const setA = new Set(a);
    const setB = new Set(b);
    if (setA.size !== setB.size) {
      return false;
    }
    return [...setA].every((val) => setB.has(val));
  }

  if (Array.isArray(a) !== Array.isArray(b)) {
    return false;
  }

  return a === b;
};
